export const dev = ''; // 前端跨域地址

export const pro = ''; // 后端跨域地址

export const domain = process.env.NODE_ENV != 'production' ? dev : pro; // 是否是开发模式